import IconSquareSlash from '@/assets/icons/lucide/square-slash.svg?react';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { cn, FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ButtonHelpShowHintsShortcuts: FC = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { user_settings, is_authorized } = use_slice_user(['user_settings', 'is_authorized']);
  /*
   * FIELDS
   */

  /*
   * EVENTS
   */

  async function on_item_selected(value: string) {
    let settings_new = user_settings.clone({ ui_hints_shortcuts_enabled: !user_settings.ui_hints_shortcuts_enabled });

    await FN_USER_SETTINGS__update(settings_new);
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  if (!is_authorized) return null;

  return (
    <UI_PRIMITIVE__dropdown_menu_item
      {...{ on_item_selected }}
      value="open_discord"
      class_name_hovered_selected="bg-component-item-selected"
      className={cn('gap-2 p-2 cursor-pointer')}
    >
      <IconSquareSlash className={`!text-bar-foreground size-5 ${user_settings.ui_hints_shortcuts_enabled ? '' : 'opacity-50'}`} />
      {user_settings.ui_hints_shortcuts_enabled
        ? t(i18n_base_ui.dropdown.help.button.help_show_hints_shortcuts.hide_title)
        : t(i18n_base_ui.dropdown.help.button.help_show_hints_shortcuts.show_title)}
    </UI_PRIMITIVE__dropdown_menu_item>
  );
};
